import UserApi from '@/services/rest/bemob/user';

export class GeneralApi {
  loading: boolean = false;
  error: boolean = false;

  userApi: UserApi = new UserApi();

  put(payload: object) {
    this.loading = true;

    return this.userApi.putUser(payload).then((payload: any) => {
      this.loading = false;
      return payload;
    }).catch((err: any) => {
      this.loading = false;
      return Promise.reject(err);
    });
  }

  updateDashboardQuery(user: any) {
    return this.userApi.updateDashboardQuery(user);
  }

}

// @ts-ignore
export default new GeneralApi();